import { useState } from 'react';
import { CatalogPlan } from '@/client/types/promotion-pricing/catalog';
import { PlanRow } from './plan-row';

interface PlanListProps {
  plans: CatalogPlan[];
  ccode: string;
  onEditPrice: (plan: CatalogPlan) => void;
  onEditConfig: (plan: CatalogPlan) => void;
  onDelete: (plan: CatalogPlan) => void;
}

/** Renders catalog rows, tracking which rows are expanded (multiple allowed). */
export const PlanList = ({ plans, ccode, onEditPrice, onEditConfig, onDelete }: PlanListProps) => {
  const [openRows, setOpenRows] = useState<Set<number>>(new Set());

  const toggle = (toid: number) =>
    setOpenRows((prev) => {
      const next = new Set(prev);
      next.has(toid) ? next.delete(toid) : next.add(toid);
      return next;
    });

  return (
    <div>
      {plans.map((plan) => (
        <PlanRow
          key={plan.toid}
          plan={plan}
          ccode={ccode}
          expanded={openRows.has(plan.toid)}
          onToggle={() => toggle(plan.toid)}
          onEditPrice={onEditPrice}
          onEditConfig={onEditConfig}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};
